module.exports = require('./lib/JSONAPISerializer');
